export default class ComponentsSelectizeController {
    constructor($element, $scope) {
        this.element = $element;
        this.scope = $scope;

        this.defaultConfig = {
            trueValue: true,
            falseValue: false,
            trueLabel: 'Yes',
            falseLabel: 'No',
            color: 'green',
            disabled: false,
            name: '',
            id: 'switch-' + Math.random() * (100 - 1) + 1
        };

        this.internalConfig = _.cloneDeep(this.defaultConfig);

        this.onChange = () => {
        };
        this.config = null;
    }

    $onInit() {
        this._initConfig();
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.config,
            () => {
                this._initConfig();
            },
            true
        );
    }

    _initConfig() {
        if (!this.config) {
            this.config = {};
        }

        this.internalConfig = _.defaultsDeep(this.config, this.defaultConfig);
    }

    changeAction(newValue) {
        this.onChange({newValue: newValue});
    }
}

ComponentsSelectizeController.$inject = [
    '$element',
    '$scope'
];

// function ComponentsSelectizeController($element, $scope) {
//     let vm = this,
//         defaultConfig = {
//             trueValue: true,
//             falseValue: false,
//             trueLabel: 'Yes',
//             falseLabel: 'No',
//             color: 'green',
//             disabled: false,
//             name: '',
//             id: 'switch-' + Math.random() * (100 - 1) + 1
//         };
//
//     vm.internalConfig = {};
//
//     vm.changeAction = changeAction;
//
//     _init();
//
//     // Internal functions
//     function _init() {
//         _initWatchers();
//         _initConfig();
//     }
//
//     function _initWatchers() {
//
//     }
//
//     function _initConfig() {
//         if (!vm.config) {
//             vm.config = {};
//         }
//
//         vm.internalConfig = _.defaultsDeep(vm.config, defaultConfig);
//     }
//
//     // Functions to bind for outside use
//     function changeAction(newValue) {
//         vm.onChange({newValue: newValue});
//     }
// }



// WEBPACK FOOTER //
// ./src/app/components/components/al-switch/controller.js